// Components==============
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle, faPlayCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import destroyFavorite from 'actions/favorite/destroy';
import storeFavorite from 'actions/favorite/store';
import { AnimatePresence, motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useState } from 'react';
import { framerMountAndScale } from 'utilities/FramerAnimations';
import Modal from '../Modal/Modal';
import RichText from '../RichText/RichText';
import './GroowTorialCard.module.scss';
// =========================

export default function GroowTorialCard({
  groowTorial,
  reference,
}: {
  groowTorial?: GroowtorialEntity;
  reference?: React.RefObject<HTMLDivElement>;
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const dispatch = useReduxAction();

  const language =
    useRedux((state) => state.authentication?.user?.language) || 'en';

  const favorite = useRedux((state) =>
    state.favorite?.entities.allIds
      .map((id) => state.favorite?.entities.byId[id])
      ?.find((fav) => fav?.favoritable_id === groowTorial?.id)
  );

  function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();

    const data = {
      type: 'tutorial',
      id: groowTorial?.id,
    };

    if (favorite) return dispatch(destroyFavorite(favorite.id, data));
    dispatch(storeFavorite(data));
  }

  return (
    <>
      <motion.div
        styleName="card"
        onClick={() => setModalIsOpen(true)}
        {...framerMountAndScale}
        ref={reference}
      >
        <img src={groowTorial?.thumbnail} alt={groowTorial?.name} />
        <div styleName="overlay">
          <FontAwesomeIcon
            icon={faPlayCircle}
            size="3x"
            opacity="0."
            style={{ pointerEvents: 'none' }}
          />
        </div>
        <button type="button" onClick={handleClick} styleName="favorite">
          {favorite ? (
            <FontAwesomeIcon icon={faCheckCircle} />
          ) : (
            <FontAwesomeIcon icon={faCircle} />
          )}
        </button>
      </motion.div>
      <AnimatePresence>
        {modalIsOpen && (
          <Modal setModalIsOpen={setModalIsOpen} video={groowTorial?.video}>
            <div styleName="modal">
              <h1>{groowTorial?.name}</h1>
              <p styleName="summary">{groowTorial?.summary}</p>
              <RichText content={groowTorial?.content?.[language]} />
            </div>
          </Modal>
        )}
      </AnimatePresence>
    </>
  );
}
